<template>
    <div class="ku-drift" @click="onHref">
        <div class="money">
            <span>余额</span>
            <span>{{ money }}</span>
            <span>元</span>
        </div>
        <div class="tit">薅一把</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            money: 0
        };
    },

    mounted() {
        let that = this
        that.$API.getDreMoney().then(res => {
            return res.data
        }).then(res => {
            that.money = res.data.money
        })
    },
    methods: {
        onHref() {
            this.$router.push('/dre');
        }
    }
}
</script>

<style lang="less" scoped>
.ku-drift {
    position: fixed;
    right: 1px;
    bottom: 200px;
    display: flex;
    background: #E45A24;
    border-radius: 80px 0 0 80px;
    color: white;
    padding: 20px 10px 20px 40px;

    .money {
        display: flex;
        flex-direction: column;
        text-align: right;
        line-height: 28px;
        padding-top: 10px;
        padding-right: 10px;
    }
    .tit {
        font-size: 32px;
        writing-mode: vertical-lr;
        -webkit-writing-mode: vertical-lr;
        -ms-writing-mode: vertical-lr;
    }
}
</style>